(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["after-add-iframe"] && !Shopify.designMode) return;
  try {
    
(function(){
let iframe = document.querySelector('#iframe-after-add');
  /// 更新PC iframe的高度
function initPCIframeHeight(height) {
    if (iframe) {
        iframe.style.height = height + 100 + 'px';
    }else {
      iframe = document.querySelector('#iframe-after-add');
      initPCIframeHeight(height);
    }
}

/// 初始化当前售后iframe的高度
function initIframeHeight(height) {
    if (iframe) {
        const client = document.documentElement.clientHeight;
        height = client > height ? client : height;
        iframe.style.height = height + "px";
    }
}
let timer = null;
document.addEventListener('scroll', function(e) {
  clearTimeout(timer);

  timer = setTimeout(function(){
    let top = 0;
    if (window.scrollY !== undefined) {
      top = window.scrollY;
    } else {
     top = document.documentElement.scrollTop;
    }

    if (iframe) {
        iframe.contentWindow.postMessage({top: top, type: 'scroll'}, '*');
    }
  }, 500);
});
  /// 接受子组件传来的消息
window.addEventListener('message', function (e) {
    try {
        const data = e.data;
        switch (data.type) {
            case 'load':
                initIframeHeight(data.height);
                break;
            case 'init':
                initPCIframeHeight(data.height);
                break;
            case 'top':
                window.scroll(0, 0);
                break;
            case 'link':
                window.location.href = data.options;
                break;
        }
    } catch (e) {
    }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["after-query-iframe"] && !Shopify.designMode) return;
  try {
    
(function(){
let iframe = document.querySelector('#iframe-after-query');
  /// 更新PC iframe的高度
function initPCIframeHeight(height) {
    if (iframe) {
        iframe.style.height = height + 100 + 'px';
    }else {
      iframe = document.querySelector('#iframe-after-query');
      initPCIframeHeight(height);
    }
}

/// 初始化当前售后iframe的高度
function initIframeHeight(height) {
    if (iframe) {
        const client = document.documentElement.clientHeight;
        height = client > height ? client : height;
        iframe.style.height = height + "px";
    }
}
let timer = null;
document.addEventListener('scroll', function(e) {
  clearTimeout(timer);

  timer = setTimeout(function(){
    let top = 0;
    if (window.scrollY !== undefined) {
      top = window.scrollY;
    } else {
     top = document.documentElement.scrollTop;
    }

    if (iframe) {
        iframe.contentWindow.postMessage({top: top, type: 'scroll'}, '*');
    }
  }, 500);
});
  /// 接受子组件传来的消息
window.addEventListener('message', function (e) {
    try {
        const data = e.data;
        switch (data.type) {
            case 'load':
                initIframeHeight(data.height);
                break;
            case 'init':
                initPCIframeHeight(data.height);
                break;
            case 'top':
                window.scroll(0, 0);
                break;
            case 'link':
                window.location.href = data.options;
                break;
        }
    } catch (e) {
    }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balcony"]) return;
  try {
    
  (function() {
      let lastTar = null;
      const btn = document.getElementById('balcony-next');
      const events = Array.prototype.slice.apply(document.getElementById('balcony-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected'); 
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[0].result = 'yes';
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question2';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bathroom"]) return;
  try {
    
  (function() {
      let lastTar = null;
      const btn = document.getElementById('bathroom-next');
      const events = Array.prototype.slice.apply(document.getElementById('bathroom-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');  
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[0].result = 'yes';
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question2';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-cart-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const ROOT_SELECTOR = '.ndev-cart-content[data-ndev-cart-content]';
    const controllers = window.ndevCartContentControllers || (window.ndevCartContentControllers = new WeakMap());

    function getNarwal() {
      return (typeof $narwal !== 'undefined') ? $narwal : null;
    }

    function getRoutesRoot() {
      if (window.$narwalCart && typeof window.$narwalCart.routesRoot === 'function') return window.$narwalCart.routesRoot();
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function getCartPath() {
      const root = getRoutesRoot();
      return root + (root.endsWith('/') ? 'cart' : '/cart');
    }

    /** 从 root.dataset 读取多语言文案 / 埋点事件名等配置。 */
    function getText(root, key, fallback) {
      const v = root && root.dataset ? root.dataset[key] : '';
      return (v && String(v).trim()) ? String(v).trim() : (fallback || '');
    }

    let overlayUnlock = null;
    function lockPage() {
      if (window.$ndevOverlay && typeof window.$ndevOverlay.lock === 'function') {
        overlayUnlock = window.$ndevOverlay.lock({ source: 'ndev-cart-content', ariaLabel: 'Loading' });
      }
    }

    function unlockPage() {
      if (typeof overlayUnlock === 'function') {
        try { overlayUnlock(); } catch (e) {}
      }
      overlayUnlock = null;
    }

    function announce(root, message) {
      if (!root) return;
      const el = root.querySelector('[data-cart-a11y-status]');
      if (!el) return;
      const msg = String(message || '').trim();
      if (!msg) return;
      el.textContent = '';
      // 让读屏更稳定地感知变化
      setTimeout(function () {
        el.textContent = msg;
      }, 10);
    }

    function tryReport(root, datasetKey, params) {
      const eventName = getText(root, datasetKey, '');
      if (!eventName) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.report !== 'function') return;
      narwal.report({
        event: eventName,
        params: Object.assign({ page: 'self', module: 'cart' }, params || {})
      });
    }

    function getProductNameFromRow(row) {
      const nameEl = row && row.querySelector ? row.querySelector('.ndev-cart-content__name') : null;
      const txt = nameEl ? nameEl.textContent : '';
      return txt ? txt.trim() : '';
    }

    function showErrorPopup(root, message) {
      const msg = String(message || '').trim() || getText(root, 'textError', 'Something went wrong, please try later.');
      announce(root, msg);

      const narwal = getNarwal();
      if (!narwal || typeof narwal.popup !== 'function') return;

      const popupId = 'ndev-cart-popup-' + String(Date.now()) + '-' + String(Math.floor(Math.random() * 10000));
      const closeText = getText(root, 'textClose', 'Close');
      const escapeHtml = function (str) {
        return String(str).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      };
      const html = `
<div class="m-popup" data-ndev-cart-popup="${popupId}">
  <div class="popup-view flex-center">
    <div class="ndev-cart-popup" style="width:min(520px, 92vw); background:#fff; border-radius:12px; padding:24px; box-shadow:0 12px 40px rgba(0,0,0,.18); position:relative;">
      <button type="button" class="close flex-center" node-name="popup_close" aria-label="${escapeHtml(closeText)}" style="position:absolute; top:12px; right:12px; width:36px; height:36px; border:none; background:rgba(0,0,0,.06); border-radius:999px; cursor:pointer;">
        <span aria-hidden="true" style="font-size:22px; line-height:1;">×</span>
      </button>
      <div style="display:flex; flex-direction:column; gap:10px;">
        <div style="font-size:14px; line-height:1.45; color:rgba(1,1,1,.8); word-break:break-word;">${escapeHtml(msg)}</div>
      </div>
    </div>
  </div>
</div>
      `.trim();

      const ins = narwal.popup({
        html: html,
        onClose: function () {
          const node = document.querySelector('[data-ndev-cart-popup="' + popupId + '"]');
          if (node && node.parentElement) node.parentElement.remove();
        }
      });

      if (ins && ins.onShow) {
        try { ins.onShow(); } catch (e) {}
      }
    }

    /**
     * 刷新单个 cart-content root：
     * - 请求 `/cart?view=cart-content`
     * - 用返回的 `.ndev-cart-content__container` 覆盖当前 container
     *
     * 说明：
     * - view 模板可能只返回 container；因此解析时同时兼容「container 直出」与「整段 section 直出」
     */
    async function refreshSection(root) {
      const container = root.querySelector('.ndev-cart-content__container');
      if (!container) return;

      const url = getCartPath() + '?view=' + encodeURIComponent('cart-content');
      const res = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      });
      if (!res.ok) throw new Error('Failed to refresh cart section');
      const html = await res.text();
      if (!html || !String(html).trim()) return;

      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      // view 模板可能只返回 container，本地 section 刷新则只需要拿到 container 即可
      const nextContainer =
        tmp.querySelector('.ndev-cart-content__container') ||
        (tmp.querySelector(ROOT_SELECTOR) ? tmp.querySelector(ROOT_SELECTOR).querySelector('.ndev-cart-content__container') : null);
      if (!nextContainer) return;

      container.innerHTML = nextContainer.innerHTML;
    }

    let externalRefreshInFlight = null;
    let externalRefreshQueued = false;

    /**
     * 由外部事件触发的刷新（例如推荐区/其他模块 add/remove 之后 emit `cart:change`）
     * - 合并短时间多次触发，避免重复请求
     * - 同时刷新页面上所有 cart-content roots（弱 Map 控制器支持多实例）
     */
    function refreshAllRootsByExternalEvent(detail) {
      const roots = document.querySelectorAll(ROOT_SELECTOR);
      if (!roots || !roots.length) return Promise.resolve();

      // 合并短时间的多次触发，避免 UI 抖动 / 重复请求
      if (externalRefreshInFlight) {
        externalRefreshQueued = true;
        return externalRefreshInFlight;
      }

      externalRefreshInFlight = (async function () {
        lockPage();
        for (var i = 0; i < roots.length; i++) {
          roots[i].classList.add('ndev-cart-content--loading');
          roots[i].setAttribute('aria-busy', 'true');
        }

        let firstErr = null;
        await Promise.all(Array.prototype.map.call(roots, function (root) {
          return refreshSection(root).catch(function (err) {
            firstErr = firstErr || err;
          });
        }));

        if (firstErr) {
          // 错误提示复用现有弹窗（只提示一次）
          showErrorPopup(roots[0], (firstErr && firstErr.message) ? String(firstErr.message) : '');
        } else {
          // 可选：给读屏一个更明确的提示（避免空 detail 时乱报）
          if (detail && detail.action === 'add') announce(roots[0], 'Cart updated.');
        }
      })().finally(function () {
        const roots2 = document.querySelectorAll(ROOT_SELECTOR);
        for (var i = 0; i < roots2.length; i++) {
          roots2[i].classList.remove('ndev-cart-content--loading');
          roots2[i].removeAttribute('aria-busy');
        }
        unlockPage();

        externalRefreshInFlight = null;
        if (externalRefreshQueued) {
          externalRefreshQueued = false;
          // 再跑一次（吸收期间的变化）
          refreshAllRootsByExternalEvent(detail);
        }
      });

      return externalRefreshInFlight;
    }

    function bindExternalCartChange() {
      if (window.ndevCartContentExternalCartChangeBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;

      window.ndevCartContentExternalCartChangeBinded = true;
      narwal.bind('cart:change', function (payload) {
        // 避免自己 emit 的 cart:change 导致本模块二次刷新
        if (payload && payload.source === 'ndev-cart-content') return;
        refreshAllRootsByExternalEvent(payload || null).catch(function () {});
      });
    }

    function bindCheckout() {
      if (window.ndevCartContentCheckoutBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;

      window.ndevCartContentCheckoutBinded = true;
      narwal.bind('cart:checkout', function (payload) {
        // 允许外部传入自定义跳转链接（兼容特殊结账流程）
        const url = payload && payload.url ? String(payload.url) : '';
        if (url) {
          window.location.href = url;
          return;
        }

        const root = getRoutesRoot();
        window.location.href = root + (root.endsWith('/') ? 'checkout' : '/checkout');
      });
    }

    /**
     * 广播 cart 变化：
     * - source 用于避免本模块收到自己发出的事件后再次刷新（见 bindExternalCartChange）
     */
    function emitCartChange(detail) {
      const narwal = getNarwal();
      if (!narwal || typeof narwal.emit !== 'function') return;
      narwal.emit('cart:change', Object.assign({ source: 'ndev-cart-content', ts: Date.now() }, detail || {}));
    }

    /**
     * 修改指定 line 的数量（quantity=0 表示删除）
     *
     * 流程：
     * - lock overlay（全局引用计数）
     * - 调用 `$narwalCart.setLineQuantity` 更新 cart
     * - 刷新本 section（HTML partial replace）
     * - emit `cart:change` 通知其它模块（推荐区等）
     */
    async function changeLine(root, line, quantity, meta) {
      if (!window.$narwalCart || typeof window.$narwalCart.setLineQuantity !== 'function') return;

      const beforeLineCount = root ? root.querySelectorAll('[data-cart-line]').length : 0;
      root.classList.add('ndev-cart-content--loading');
      root.setAttribute('aria-busy', 'true');
      lockPage();

      try {
        const cart = await window.$narwalCart.setLineQuantity({ line: line, quantity: quantity });

        const count = window.$narwalCart.countItems ? window.$narwalCart.countItems(cart) : (cart && cart.item_count) || 0;
        if (window.$narwalCart.updateHeaderCartCount) window.$narwalCart.updateHeaderCartCount(count);

        if (quantity === 0 && beforeLineCount === 1) {
          window.location.href = getRoutesRoot() + 'cart';
        } else {
          await refreshSection(root);
        }

        // ✅ 广播删除/改数量事件：推荐区等其它模块可监听并自行刷新
        const action = (quantity === 0) ? 'remove' : 'update';
        emitCartChange({
          action: action,
          line: line,
          quantity: quantity,
          btn: meta && meta.btn ? meta.btn : undefined,
          cart: cart
        });
      } catch (err) {
        const msg = (err && err.message) ? String(err.message) : getText(root, 'textError', '');
        const isLimit = quantity > 0 && err && (err.status === 422);

        if (isLimit) {
          tryReport(root, 'eventQtyLimit', {
            btn: 'qty_limit',
            action: meta && meta.action ? meta.action : undefined,
            quantity: quantity
          });
        } else {
          tryReport(root, 'eventRequestError', {
            btn: (meta && meta.btn) ? meta.btn : 'request_error',
            action: meta && meta.action ? meta.action : undefined,
            quantity: quantity
          });
        }

        showErrorPopup(root, msg);

        // 尝试回滚 UI 到最新 cart 状态（避免数量选择器与真实数据不一致）
        await refreshSection(root).catch(function () {});
      } finally {
        unlockPage();
        root.classList.remove('ndev-cart-content--loading');
        root.removeAttribute('aria-busy');
      }
    }

    function initOne(root) {
      if (!root) return;
      if (root.getAttribute('data-ndev-cart-initialized') === '1') return;
      root.setAttribute('data-ndev-cart-initialized', '1');

      function onClick(e) {
        // 结账按钮兜底：
        // - cart-content 刷新使用 innerHTML 替换，snippets/ndev-standard-button.liquid 中的 emit 初始化脚本不会执行
        // - 导致刷新后的 checkout 按钮无法触发 `cart:checkout`
        // - 这里用冒泡阶段兜底：如果 emit 脚本已生效，它会在 capture 阶段 stopPropagation，本逻辑不会触发
        const checkoutBtn = e?.target?.closest('.ndev-cart-content__checkout-button') ?? null;
        if (checkoutBtn && root.contains(checkoutBtn)) {
          if (checkoutBtn.classList.contains('ndev-standard-button--disabled') || checkoutBtn.disabled) return;
          e.preventDefault();
          e.stopPropagation();
          try {
            if (window.$narwal?.emit && typeof window.$narwal.emit === 'function') {
              window.$narwal.emit('cart:checkout', {});
              return;
            }
          } catch (err) {}

          // 兜底：直接跳转结账
          const rr = getRoutesRoot();
          window.location.href = rr + (rr.endsWith('/') ? 'checkout' : '/checkout');
          return;
        }

        const backLink = e?.target?.closest('[data-continue-back]') ?? null;
        if (backLink && root.contains(backLink)) {
          e.preventDefault();
          e.stopPropagation();
          if (window.history && typeof window.history.back === 'function' && window.history.length > 1) {
            window.history.back();
          } else {
            window.location.href = getRoutesRoot();
          }
          return;
        }

        const btn = e.target && e.target.closest ? e.target.closest('[data-cart-remove]') : null;
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();

        const line = parseInt(btn.getAttribute('data-line'), 10);
        if (!line) return;

        const row = btn.closest('[data-cart-line]');
        const product = getProductNameFromRow(row);
        tryReport(root, 'eventRemove', { btn: 'remove', product: product });

        changeLine(root, line, 0, { btn: 'remove' }).catch(function (err) {
          console.error(err);
        });
      }

      function onCaptureClick(e) {
        const checkoutBtn = e.target && e.target.closest ? e.target.closest('.ndev-cart-content__checkout-button') : null;
        if (!checkoutBtn || !root.contains(checkoutBtn)) return;
        tryReport(root, 'eventCheckout', { btn: 'checkout' });
      }

      root.addEventListener('click', onClick);
      root.addEventListener('click', onCaptureClick, true);

      controllers.set(root, {
        root: root,
        destroy: function () {
          root.removeEventListener('click', onClick);
          root.removeEventListener('click', onCaptureClick, true);
          root.removeAttribute('data-ndev-cart-initialized');
        },
        changeLine: function (line, qty, meta) {
          return changeLine(root, line, qty, meta);
        }
      });
    }

    function initAll() {
      const list = document.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) {
        initOne(list[i]);
      }
    }

    function bindQuantityChange() {
      if (window.ndevCartContentQuantityBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;

      window.ndevCartContentQuantityBinded = true;
      narwal.bind('quantity:change', function (ev) {
        if (!ev || typeof ev.lineIndex === 'undefined') return;
        const selector = ev.selector;
        const root = selector && selector.closest ? selector.closest(ROOT_SELECTOR) : null;
        if (!root) return;

        const controller = controllers.get(root);
        if (!controller) return;

        const line = parseInt(ev.lineIndex, 10);
        const qty = parseInt(ev.newQuantity, 10);
        if (!line || isNaN(qty)) return;

        const row = root.querySelector('[data-cart-line="' + line + '"]');
        const product = getProductNameFromRow(row);
        tryReport(root, 'eventQtyChange', {
          btn: 'qty_change',
          product: product,
          action: ev.action,
          quantity: qty
        });

        controller.changeLine(line, qty, { btn: 'qty_change', action: ev.action }).catch(function (err) {
          console.error(err);
        });
      });
    }

    function bindQuantityLimit() {
      if (window.ndevCartContentQuantityLimitBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;

      window.ndevCartContentQuantityLimitBinded = true;
      narwal.bind('quantity:limit', function (ev) {
        const selector = ev && ev.selector;
        const root = selector && selector.closest ? selector.closest(ROOT_SELECTOR) : null;
        if (!root) return;

        const line = parseInt(ev.lineIndex, 10);
        const row = line ? root.querySelector('[data-cart-line="' + line + '"]') : null;
        const product = getProductNameFromRow(row);

        const msg = getText(root, 'textVariantUnavailable', 'Unavailable');
        announce(root, msg);

        tryReport(root, 'eventQtyLimit', {
          btn: 'qty_limit',
          product: product,
          action: ev.action,
          reason: ev.reason,
          attempted_quantity: ev.attemptedQuantity,
          current_quantity: ev.currentQuantity,
          max_quantity: ev.maxQuantity
        });
      });
    }

    // 绑定 narwal 事件（可能晚加载，所以这里既尝试一次，也会在 cart:init / DOMContentLoaded 再尝试）
    bindQuantityChange();
    bindQuantityLimit();
    bindExternalCartChange();
    bindCheckout();

    // 初始化时机：cart api 就绪优先，其次 DOMContentLoaded
    if (window.$narwalCart) {
      initAll();
    } else {
      const narwal = getNarwal();
      if (narwal && typeof narwal.bind === 'function') {
        narwal.bind('cart:init', function () {
          bindQuantityChange();
          bindQuantityLimit();
          bindExternalCartChange();
          bindCheckout();
          initAll();
        });
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          bindQuantityChange();
          bindQuantityLimit();
          bindExternalCartChange();
          bindCheckout();
          initAll();
        });
      }
    }

    // Shopify 主题编辑器事件（仅在 design mode 触发，这里可安全常驻监听）
    document.addEventListener('shopify:section:load', function (event) {
      const sid = event && event.detail ? event.detail.sectionId : '';
      if (!sid) return;
      const root = document.querySelector(ROOT_SELECTOR + '[data-section-id="' + String(sid) + '"]');
      if (root) initOne(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      const sid = event && event.detail ? event.detail.sectionId : '';
      if (!sid) return;
      const root = document.querySelector(ROOT_SELECTOR + '[data-section-id="' + String(sid) + '"]');
      const controller = root ? controllers.get(root) : null;
      if (controller && controller.destroy) controller.destroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-cart-recommend"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.ndevCartRecommendClientInited) return;
    window.ndevCartRecommendClientInited = true;

    const ROOT_SELECTOR = '.ndev-cart-recommend[data-ndev-cart-recommend]';
    const controllers = window.ndevCartRecommendControllers || (window.ndevCartRecommendControllers = new WeakMap());

    function getNarwal() {
      return (typeof $narwal !== 'undefined') ? $narwal : null;
    }

    function getRoutesRoot() {
      if (window.$narwalCart && typeof window.$narwalCart.routesRoot === 'function') {
        return window.$narwalCart.routesRoot();
      }
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function getCartPath() {
      const root = getRoutesRoot();
      return root + (root.endsWith('/') ? 'cart' : '/cart');
    }

    function setLoading(root, on) {
      if (!root) return;
      if (on) {
        root.classList.add('ndev-cart-recommend--loading');
        root.setAttribute('aria-busy', 'true');
      } else {
        root.classList.remove('ndev-cart-recommend--loading');
        root.removeAttribute('aria-busy');
      }
    }

    /**
     * 只在“页面本来就有遮罩”的情况下续锁：
     * - 典型场景：cart-content 删除/改数量时已锁遮罩，推荐区刷新时补锁，避免遮罩提前消失
     * - 非典型场景：推荐区自己主动刷新（如仅滑动/重绘）不应强制出现遮罩
     */
    function lockOverlayIfActive() {
      const overlay = window.$ndevOverlay;
      if (!overlay || typeof overlay.lock !== 'function' || typeof overlay.getCount !== 'function') return null;
      if (overlay.getCount() <= 0) return null;
      try {
        return overlay.lock({ source: 'ndev-cart-recommend', ariaLabel: 'Loading' });
      } catch (e) {
        return null;
      }
    }

    function destroySwiper(root) {
      if (!root) return;
      const c = controllers.get(root);
      if (c && typeof c.destroy === 'function') {
        try { c.destroy(); } catch (e) {}
      }
      controllers.delete(root);
      root.removeAttribute('data-ndev-cart-recommend-inited');
    }

    function initOne(root) {
      if (!root || root.getAttribute('data-ndev-cart-recommend-inited') === '1') return;
      const wrap =
        root.querySelector('[data-ndev-cart-recommend-swiper-root]') ||
        root.querySelector('.ndev-cart-recommend__swiper-wrap');
      if (!wrap) return;

      const swiperEl = wrap.querySelector('.ndev-cart-recommend__swiper');
      if (!swiperEl) return;

      root.setAttribute('data-ndev-cart-recommend-inited', '1');

      let swiper = null;
      try {
        if (typeof Swiper !== 'undefined') {
          swiper = new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            breakpoints: { 1024: { spaceBetween: 20 } },
            navigation: {
              prevEl: wrap.querySelector('[data-ndev-cart-recommend-prev]'),
              nextEl: wrap.querySelector('[data-ndev-cart-recommend-next]'),
              disabledClass: 'swiper-button-disabled',
            },
          });
        }
      } catch (e) {}

      controllers.set(root, {
        swiper: swiper,
        wrap: wrap,
        destroy: function () {
          try {
            swiper && swiper.destroy && swiper.destroy(true, true);
          } catch (e) {}
        }
      });
    }

    function initAll() {
      const roots = document.querySelectorAll(ROOT_SELECTOR);
      roots.forEach(initOne);
    }

    function emitCartChange(detail) {
      const narwal = getNarwal();
      if (!narwal || typeof narwal.emit !== 'function') return;
      narwal.emit('cart:change', Object.assign({ source: 'ndev-cart-recommend', ts: Date.now() }, detail || {}));
    }

    async function addToCart(variantId) {
      // 优先使用 $narwalCart
      if (window.$narwalCart && typeof window.$narwalCart.addItem === 'function') {
        return await window.$narwalCart.addItem({ variantId: variantId, quantity: 1 });
      }
    }

    let refreshAllInFlight = null;
    let refreshAllQueued = false;

    /**
     * 刷新推荐区：
     * - 合并短时间多次触发（inFlight + queued）
     * - fetch view html 后批量替换每个 root 的 body
     * - 更新 `data-has-recommend` + 重建 Swiper
     *
     * 注意：本函数只刷新推荐区自身，不负责刷新 cart-content。
     * cart-content 的刷新由它自己监听 `cart:change` 完成。
     */
    async function refreshAll() {
      const roots = document.querySelectorAll(ROOT_SELECTOR);
      if (!roots || !roots.length) return;

      if (refreshAllInFlight) {
        refreshAllQueued = true;
        return refreshAllInFlight;
      }

      refreshAllInFlight = (async function () {
        const overlayUnlock = lockOverlayIfActive();
        roots.forEach(function (r) { setLoading(r, true); destroySwiper(r); });

        try {
          const url = getCartPath() + '?view=' + encodeURIComponent('cart-recommend');
          const res = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' }
          });
          if (!res.ok) throw new Error('Failed to refresh cart recommend');

          const html = await res.text();
          const tmp = document.createElement('div');
          tmp.innerHTML = html;

          const nextBody = tmp.querySelector('[data-ndev-cart-recommend-body]');
          const nextBodyHtml = nextBody ? nextBody.innerHTML : '';

          roots.forEach(function (root) {
            const body = root.querySelector('[data-ndev-cart-recommend-body]');
            if (body) body.innerHTML = nextBodyHtml;

            const hasSlides = !!root.querySelector('.swiper-slide');
            root.setAttribute('data-has-recommend', hasSlides ? '1' : '0');
            if (hasSlides) initOne(root);
          });
        } finally {
          if (typeof overlayUnlock === 'function') {
            try { overlayUnlock(); } catch (e) {}
          }
        }
      })().finally(function () {
        const roots2 = document.querySelectorAll(ROOT_SELECTOR);
        roots2.forEach(function (r) { setLoading(r, false); });

        refreshAllInFlight = null;
        if (refreshAllQueued) {
          refreshAllQueued = false;
          refreshAll();
        }
      });

      return refreshAllInFlight;
    }

    function bindExternalCartChange() {
      if (window.ndevCartRecommendExternalCartChangeBinded) return;
      const narwal = getNarwal();
      if (!narwal || typeof narwal.bind !== 'function') return;
      window.ndevCartRecommendExternalCartChangeBinded = true;
      narwal.bind('cart:change', function () {
        refreshAll().catch(function () {});
      });
    }

    async function handleAddToCart(btn) {
      const variantId = btn && btn.dataset ? btn.dataset.variantId : '';
      if (!variantId) return;

      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true');

      // 推荐区“主动加购”必须立刻显示遮罩：
      // 否则会出现：推荐区刷新完了，cart-content 才开始加锁，导致遮罩“晚到”。
      let overlayUnlock = null;
      try {
        if (window.$ndevOverlay && typeof window.$ndevOverlay.lock === 'function') {
          overlayUnlock = window.$ndevOverlay.lock({ source: 'ndev-cart-recommend-atc', ariaLabel: 'Loading' });
        }
      } catch (e) {
        overlayUnlock = null;
      }

      // 让浏览器先渲染出遮罩首帧，再做后续异步请求/DOM 替换
      try {
        await new Promise(function (resolve) { requestAnimationFrame(resolve); });
      } catch (e) {}

      try {
        const result = await addToCart(variantId);
        // ✅ 加购成功后同步 header 数量
        await Promise.allSettled([
          window.$narwalCart?.syncHeaderCartCount?.(),
          refreshAll()
        ]);
        emitCartChange({ action: 'add', variantId: variantId, quantity: 1, result: result });
      } catch (e) {
        // 静默失败：错误提示交给 cart-content/全局兜底
      } finally {
        btn.setAttribute('aria-disabled', 'false');
        if (typeof overlayUnlock === 'function') {
          try { overlayUnlock(); } catch (e) {}
        }
      }
    }

    document.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest ? e.target.closest('[data-ndev-cart-recommend-atc]') : null;
      if (!btn) return;
      e.preventDefault();
      handleAddToCart(btn);
    });

    // 初始化：即使当前推荐为空也要常驻监听
    bindExternalCartChange();
    document.addEventListener('DOMContentLoaded', function () {
      bindExternalCartChange();
      initAll();
    });
    document.addEventListener('shopify:section:load', function () {
      initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-category-navbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-category-navbar';
    const ROOT_SELECTOR = '[data-ndev-category-navbar]';
    const INIT_ATTR = 'data-' + NS + '-initialized';
    const ITEM_SELECTOR = '[data-ndev-category-navbar-item]';
    const MAIN_SECTIONS_SELECTOR = '#main-content .shopify-section';
    const SITE_HEADER_SELECTOR = '#site-header';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function getHeaderOffsetHeight(root) {
      let offset = 0;
      const header = document.querySelector(SITE_HEADER_SELECTOR);
      if (header && header.getBoundingClientRect) {
        offset += Math.round(header.getBoundingClientRect().height || 0);
      }
      // 如果本导航吸顶，定位时也要预留它本身的高度
      if (root && root.classList && root.classList.contains('is-sticky') && root.getBoundingClientRect) {
        offset += Math.round(root.getBoundingClientRect().height || 0);
      }
      return offset;
    }

    function updateStickyTop(root) {
      try {
        if (!root || !root.classList || !root.classList.contains('is-sticky')) return;
        const header = document.querySelector(SITE_HEADER_SELECTOR);
        // 关键：sticky 的 top 不能大于该元素“正常位置”的 top，否则 sticky 永远不会触发。
        // 这个主题里 #main-content 通常用 margin-top / padding-top 给 fixed header 让位，
        // 所以这里优先用 main-content 的 offset 作为 sticky top（更贴近页面真实布局）。
        let top = 0;
        const main = document.getElementById('main-content');
        if (main) {
          const ms = window.getComputedStyle(main);
          top = parseFloat(ms.marginTop) || parseFloat(ms.paddingTop) || 0;
        }
        // fallback：没有 main-content offset 时，再用 header 的可视 bottom
        if (!top && header && header.getBoundingClientRect) {
          top = Math.max(0, header.getBoundingClientRect().bottom || 0);
        }
        const host = (root.__ndevStickyHost && root.__ndevStickyHost.style) ? root.__ndevStickyHost : root;
        host.style.setProperty('--ndev-category-navbar-sticky-top', top + 'px');
      } catch (e) {}
    }

    function setActive(root, item, state) {
      if (!root || !item) return;
      if (state && state.activeItem === item) return; // 关键保护：active 未变化不更新，避免抖动/回滚

      const list = root.querySelectorAll(ITEM_SELECTOR);
      for (let i = 0; i < list.length; i++) {
        list[i].classList.remove('is-active');
        try { list[i].removeAttribute('aria-current'); } catch (e) {}
      }
      item.classList.add('is-active');
      try {
        const type = item.getAttribute('data-item-type');
        item.setAttribute('aria-current', type === 'link' ? 'page' : 'true');
      } catch (e) {}

      if (state) state.activeItem = item;

      // 只做“横向滚动”，绝不使用 scrollIntoView（它可能触发页面纵向滚动导致回顶）
      try {
        const container = root.querySelector('.ndev-category-navbar__container');
        if (!container) return;
        if (container.scrollWidth <= container.clientWidth + 1) return; // 无溢出无需滚

        const itemRect = item.getBoundingClientRect();
        const conRect = container.getBoundingClientRect();
        const itemCenter = (itemRect.left - conRect.left) + itemRect.width / 2;
        const targetLeft = Math.max(0, itemCenter - container.clientWidth / 2);

        const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        container.scrollTo({ left: targetLeft, behavior: reduced ? 'auto' : 'smooth' });
      } catch (e) {}
    }

    function reportClick(node) {
      $narwal.report({ target: node }, node);
    }

    function scrollToAnchorIndex(root, anchorIndex) {
      const idx = parseInt(anchorIndex, 10);
      if (!idx || idx < 1) return false;

      const sections = document.querySelectorAll(MAIN_SECTIONS_SELECTOR);
      if (!sections || !sections.length) return false;

      const target = sections[idx - 1];
      if (!target || !target.getBoundingClientRect) return false;

      const offset = getHeaderOffsetHeight(root);
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);

      const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
      return true;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 初始化逻辑：点击上报（$narwal.report）、link 跳转、anchor 定位
      const state = { activeItem: null };
      // 让 sticky 挂到更外层的 .shopify-section 上（它的父级是整页内容，sticky 才能跨页面生效）
      try {
        if (root.classList && root.classList.contains('is-sticky')) {
          const host = root.closest('.shopify-section') || root.parentElement;
          if (host && host.classList) {
            host.classList.add('ndev-category-navbar__sticky-wrapper');
            root.__ndevStickyHost = host;
          }
        }
      } catch (e) {}

      updateStickyTop(root);
      const anchorItemMap = {}; // { [index:number]: HTMLElement }
      const items = root.querySelectorAll(ITEM_SELECTOR);
      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        if (it && it.getAttribute && it.getAttribute('data-item-type') === 'anchor') {
          const ai = parseInt(it.getAttribute('data-anchor-index') || '', 10);
          if (ai) anchorItemMap[ai] = it;
        }
      }

      function onClickCapture(ev) {
        const target = ev && ev.target ? ev.target : null;
        if (!target || !target.closest) return;
        const item = target.closest(ITEM_SELECTOR);
        if (!item || !root.contains(item)) return;

        // 统一拦截本组件的埋点，避免依赖全局 click 导致跳转丢失/重复上报
        try {
          if (item.classList && item.classList.contains('__ga4_report__')) {
            reportClick(item);
            if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
            if (ev.stopPropagation) ev.stopPropagation();
          }
        } catch (e) {}

        const type = item.getAttribute('data-item-type');
        if (type === 'link') {
          // 正常跳转逻辑：支持新开窗口/修饰键点击不拦截
          const href = item.getAttribute('href');
          if (!href) return;

          const isModified = !!(ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey);
          const targetAttr = (item.getAttribute('target') || '').toLowerCase();
          if (isModified || targetAttr === '_blank') return;

          ev.preventDefault();
          // 给上报留一点时间，避免跳转打断发送
          setTimeout(function () {
            try { window.location.assign(href); } catch (e) { window.location.href = href; }
          }, 160);
          return;
        }

        if (type === 'anchor') {
          ev.preventDefault();
          setActive(root, item, state);
          scrollToAnchorIndex(root, item.getAttribute('data-anchor-index'));
          return;
        }
      }

      let ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateStickyTop(root);

          const sections = document.querySelectorAll(MAIN_SECTIONS_SELECTOR);
          if (!sections || !sections.length) return;

          const offset = getHeaderOffsetHeight(root);
          // 用“header(含吸顶 nav) 底部那条线”落点来判断当前激活 section
          let activeIdx = state.activeIndex || 1;
          let marker = offset + 1;
          let found = false;
          for (let i = 0; i < sections.length; i++) {
            const rect = sections[i].getBoundingClientRect();
            if (!rect) continue;
            // marker 线落在这个 section 的可视区域内
            if (rect.top <= marker && rect.bottom > marker) {
              activeIdx = i + 1;
              found = true;
              break;
            }
          }

          // 兜底：如果已经滚到页面底部，强制激活最后一个（常见：最后一个 section 不足以越过 marker）
          if (!found) {
            try {
              const doc = document.documentElement;
              const isBottom = (window.scrollY + window.innerHeight) >= ((doc && doc.scrollHeight) ? (doc.scrollHeight - 2) : 0);
              if (isBottom) activeIdx = sections.length;
              else activeIdx = activeIdx || 1;
            } catch (e) {}
          }

          state.activeIndex = activeIdx;

          const anchorItem = anchorItemMap[activeIdx];
          if (anchorItem) setActive(root, anchorItem, state);
        });
      }

      root.addEventListener('click', onClickCapture, true);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      // 初始化一次，确保首屏 active 正确（尤其是直接带滚动位置进入）
      onScroll();

      let ro = null;
      try {
        const header = document.querySelector(SITE_HEADER_SELECTOR);
        if (header && window.ResizeObserver) {
          ro = new ResizeObserver(function () {
            updateStickyTop(root);
            onScroll();
          });
          ro.observe(header);
        }
      } catch (e) {}

      controllers.set(root, {
        root,
        destroy: function () {
          // 清理事件监听器、定时器等（注意移除你在 init 里绑定的监听）
          try { root.removeEventListener('click', onClickCapture, true); } catch (e) {}
          try { window.removeEventListener('scroll', onScroll, { passive: true }); } catch (e) { window.removeEventListener('scroll', onScroll); }
          try { window.removeEventListener('resize', onScroll, { passive: true }); } catch (e) { window.removeEventListener('resize', onScroll); }
          try { if (ro && ro.disconnect) ro.disconnect(); } catch (e) {}
          try {
            const host = root.__ndevStickyHost;
            if (host && host.classList) host.classList.remove('ndev-category-navbar__sticky-wrapper');
            delete root.__ndevStickyHost;
          } catch (e) {}
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-collection-list';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;

    const instances = new WeakMap();

    function checkNavigationButtons(root, swiper, swiperEl, navButtons) {
      if (!root || !swiper || !swiperEl || !navButtons) return;
      const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!swiperWrapper) return;

      const containerWidth = swiperEl.offsetWidth;
      const contentWidth = swiperWrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const swiperEl = root.querySelector('.collection-list-swiper');
      const navButtons = root.querySelector('.collection-list__nav-buttons');
      if (!swiperEl) return;

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: root.querySelector('.collection-list__nav-button--next'),
          prevEl: root.querySelector('.collection-list__nav-button--prev'),
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          768: {
            slidesPerView: 6,
            centerInsufficientSlides: true,
          },
        },
        on: {
          init: function () {
            this.el.classList.add('grab');
            window.setTimeout(() => checkNavigationButtons(root, swiper, swiperEl, navButtons), 100);
          },
          sliderMove: function () {
            this.el.classList.add('grabbing');
          },
          slideChangeTransitionEnd: function () {
            this.el.classList.remove('grabbing');
          },
          touchEnd: function () {
            this.el.classList.remove('grabbing');
          },
        },
      });

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          checkNavigationButtons(root, swiper, swiperEl, navButtons);
          swiper.update();
        }, 250);
      };

      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, { swiper, onResize });
    }

    function destroyOne(root) {
      const inst = instances.get(root);
      if (!inst) return;

      window.removeEventListener('resize', inst.onResize);
      try {
        inst.swiper.destroy(true, true);
      } catch (e) {}

      root.removeAttribute(INIT_ATTR);
      instances.delete(root);
    }

    function initAll(container = document) {
      const roots = container.querySelectorAll(ROOT_SELECTOR);
      roots.forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const roots = event.target.querySelectorAll(ROOT_SELECTOR);
      roots.forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-community-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-community-video';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;

    const instances = new WeakMap();

    function getModule(root) {
      const sectionId = root?.dataset?.sectionId || '';
      if (!sectionId) return '';
      const parts = sectionId.split('__');
      return parts[parts.length - 1] || sectionId;
    }

    function checkNavigationButtons(root, swiper, swiperContainer, navButtons) {
      if (!root || !swiper || !swiperContainer || !navButtons) return;
      const wrapper = swiperContainer.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperContainer.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const swiperContainer = root.querySelector('.swiper-container');
      const navButtons = root.querySelector('.ndev-community-video__nav-buttons');
      const tabItems = Array.from(root.querySelectorAll('.tab-item'));
      const swiperSlides = Array.from(root.querySelectorAll('.swiper-slide'));

      let swiper = null;

      const destroySwiper = () => {
        swiper?.destroy?.(true, true);
        swiper = null;
      };

      const createSwiper = () => {
        if (!swiperContainer || typeof window.Swiper === 'undefined') return;
        destroySwiper();
        swiper = new window.Swiper(swiperContainer, {
          slidesPerView: 'auto',
          initialSlide: 0,
          spaceBetween: 0,
          navigation: {
            nextEl: root.querySelector('.ndev-community-video__nav-button--next'),
            prevEl: root.querySelector('.ndev-community-video__nav-button--prev'),
            disabledClass: 'swiper-button-disabled',
          },
          on: {
            init: function () {
              window.setTimeout(() => checkNavigationButtons(root, swiper, swiperContainer, navButtons), 100);
            },
          },
        });
      };

      const switchTab = (targetCategory) => {
        tabItems.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });

        const targetTab = tabItems.find((item) => item.dataset.category === targetCategory) || null;
        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.setAttribute('aria-selected', 'true');
        }

        swiperSlides.forEach((slide) => {
          const slideCategory = slide.dataset.category;
          if (!slideCategory || slideCategory === targetCategory) {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        });

        window.setTimeout(() => {
          createSwiper();
          checkNavigationButtons(root, swiper, swiperContainer, navButtons);
          swiper?.update?.();
          swiper?.slideTo?.(0, 0);
        }, 0);

        if (window.$narwal && typeof window.$narwal.report === 'function') {
          window.$narwal.report({
            event: 'tab_switch',
            params: {
              page: 'self',
              module: getModule(root),
              btn: targetTab ? targetTab.textContent.trim() : targetCategory,
            },
          });
        }
      };

      const onTabClick = (ev) => {
        const btn = ev.currentTarget;
        const category = btn?.dataset?.category;
        if (!category) return;
        switchTab(category);
      };

      tabItems.forEach((item) => item.addEventListener('click', onTabClick));

      // initial
      if (tabItems.length > 0) {
        const first = tabItems[0].dataset.category;
        if (first) switchTab(first);
      } else {
        swiperSlides.forEach((slide) => slide.classList.remove('hidden'));
        createSwiper();
        checkNavigationButtons(root, swiper, swiperContainer, navButtons);
      }

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          checkNavigationButtons(root, swiper, swiperContainer, navButtons);
          swiper?.update?.();
        }, 250);
      };
      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, {
        destroy: () => {
          tabItems.forEach((item) => item.removeEventListener('click', onTabClick));
          window.removeEventListener('resize', onResize);
          if (resizeTimeout) window.clearTimeout(resizeTimeout);
          destroySwiper();
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function destroyOne(root) {
      const inst = instances.get(root);
      if (!inst) return;
      inst.destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-expansion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-expansion';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;
    const instances = new WeakMap();

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const swiperContainer = root.querySelector('.ndev-expansion-pc-cards .swiper-container');
      const paginationEl = root.querySelector('.ndev-expansion-pc-cards .swiper-pagination');
      if (!swiperContainer || !paginationEl) return;

      const pcSwiper = new window.Swiper(swiperContainer, {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: false,
        autoplay: false,
        pagination: {
          el: paginationEl,
          clickable: true,
          type: 'bullets',
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, () => {
        try {
          pcSwiper.destroy(true, true);
        } catch (_) {}
        root.removeAttribute(INIT_ATTR);
      });
    }

    function destroyOne(root) {
      const destroy = instances.get(root);
      if (!destroy) return;
      destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-explore-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-explore-product';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;

    const instances = new WeakMap();

    function checkNavigationButtons(swiperEl, navButtons, swiper) {
      if (!swiperEl || !navButtons || !swiper) return;
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperEl.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const swiperEl = root.querySelector('.ndev-explore-product-swiper');
      const navButtons = root.querySelector('.ndev-explore-product__nav-buttons');
      if (!swiperEl) return;

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        loop: false,
        navigation: {
          nextEl: root.querySelector('.ndev-explore-product__nav-button--next'),
          prevEl: root.querySelector('.ndev-explore-product__nav-button--prev'),
          disabledClass: 'swiper-button-disabled',
        },
        on: {
          init: function () {
            this.el.classList.add('grab');
            window.setTimeout(() => checkNavigationButtons(swiperEl, navButtons, swiper), 100);
          },
          sliderMove: function () {
            this.el.classList.add('grabbing');
          },
          slideChangeTransitionEnd: function () {
            this.el.classList.remove('grabbing');
          },
          touchEnd: function () {
            this.el.classList.remove('grabbing');
          },
        },
      });

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          checkNavigationButtons(swiperEl, navButtons, swiper);
          swiper.update();
        }, 250);
      };
      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, () => {
        window.removeEventListener('resize', onResize);
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        try {
          swiper.destroy(true, true);
        } catch (_) {}
        root.removeAttribute(INIT_ATTR);
      });
    }

    function destroyOne(root) {
      const destroy = instances.get(root);
      if (!destroy) return;
      destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-navbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-navbar';
    const ROOT_SELECTOR = '[data-ndev-navbar]';
    const SCROLL_BTN_SELECTOR = '[data-btn-purpose="scroll"]';
    const MAIN_SECTIONS_SELECTOR = '#main-content .shopify-section';
    const SITE_HEADER_SELECTOR = '#site-header';

    const LOCK_IDLE_MS = 220; // 停止滚动多久后解锁
    const LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function getHeaderOffsetHeight(root, headerEl) {
      let offset = 0;
      if (headerEl) offset += Math.round(headerEl.getBoundingClientRect().height || 0);
      if (root && root.classList.contains('is-sticky')) offset += Math.round(root.getBoundingClientRect().height || 0);
      return offset;
    }

    function updateStickyTop(root, headerEl) {
      if (!root || !root.classList.contains('is-sticky')) return;
      requestAnimationFrame(() => {
        const top = headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom || 0) : 0;
        const host = root.__ndevStickyHost && root.__ndevStickyHost.style ? root.__ndevStickyHost : root;
        host.style.setProperty('--ndev-navbar-sticky-top', top + 'px');
      })
    }

    function setActive(root, item, state) {
      if (!root || !item) return;

      // item 是带 data-btn-purpose="scroll" 的 <a>/<button> 元素，即内层 .ndev-button__btn
      if (state && state.activeItem === item) return;

      // 只更新导航列表中的按钮（不影响右侧区域）
      var listContainer = root.querySelector('.ndev-navbar__list');
      if (!listContainer) return;

      listContainer.querySelectorAll('.ndev-button .ndev-button__btn').forEach(function (el) {
        el.classList.remove('is-active');
      });

      item.classList.add('is-active');
      if (state) state.activeItem = item;

      // 激活按钮滚动居中（PC 和移动端都适用）
      // 需要找外层 section 来计算滚动位置
      var btnWrapper = item.closest('.ndev-button');
      var r = (btnWrapper || item).getBoundingClientRect();
      var c = listContainer.getBoundingClientRect();
      var center = r.left - c.left + r.width / 2;
      var left = Math.max(0, center - listContainer.clientWidth / 2);
      var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      listContainer.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }

    function computeMatchedAnchorIndex(anchorItemMap, cachedSections, anchorKeys, headerOffset) {
      if (!cachedSections.length) return null;

      var marker = headerOffset + 1;
      var globalIdx = 1;
      for (var i = cachedSections.length - 1; i >= 0; i--) {
        var rect = cachedSections[i].getBoundingClientRect();
        if (rect && rect.top <= marker) {
          globalIdx = i + 1;
          break;
        }
      }

      // 精确匹配
      if (anchorItemMap[globalIdx]) return globalIdx;

      // 找最近的小于等于当前 section index
      var matched = null;
      for (var j = 0; j < anchorKeys.length; j++) {
        if (anchorKeys[j] <= globalIdx) matched = anchorKeys[j];
      }
      return matched;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && controller.destroy) controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      destroyOne(root);

      var headerEl = document.querySelector(SITE_HEADER_SELECTOR);
      var mainContent = document.querySelector('#main-content');
      var cachedSections = Array.prototype.slice.call(document.querySelectorAll(MAIN_SECTIONS_SELECTOR));

      function refreshSectionsCache() {
        cachedSections = Array.prototype.slice.call(document.querySelectorAll(MAIN_SECTIONS_SELECTOR));
      }

      var mo = null;
      if (mainContent && window.MutationObserver) {
        mo = new MutationObserver(refreshSectionsCache);
        mo.observe(mainContent, { childList: true });
      }

      var state = {
        activeItem: null,
        lock: null,
      };

      // 设置 sticky host
      if (root.classList.contains('is-sticky')) {
        var host = root.closest('.shopify-section') || root.parentElement;
        if (host && host.classList) {
          host.classList.add('ndev-navbar__sticky-wrapper');
          root.__ndevStickyHost = host;
        }
      }

      updateStickyTop(root, headerEl);

      // 收集所有带 data-ndev-btn-scroll 属性的按钮，构建映射
      var anchorItemMap = {};
      var anchorKeys = [];
      var listContainer = root.querySelector('.ndev-navbar__list');
      if (listContainer) {
        listContainer.querySelectorAll(SCROLL_BTN_SELECTOR).forEach(function (el) {
          var ai = parseInt(el.getAttribute('data-scroll-section-index') || '', 10);
          if (ai) anchorItemMap[ai] = el;
        });
      }
      anchorKeys = Object.keys(anchorItemMap)
        .map(Number)
        .sort(function (a, b) {
          return a - b;
        });

      // 默认激活第一个
      if (anchorKeys.length > 0 && anchorItemMap[anchorKeys[0]]) {
        setActive(root, anchorItemMap[anchorKeys[0]], state);
      }

      var ticking = false;
      var lockIdleTimer = null;
      var lockMaxTimer = null;
      var unbindUserCancel = null;

      function clearLock() {
        state.lock = null;
        if (lockIdleTimer) {
          clearTimeout(lockIdleTimer);
          lockIdleTimer = null;
        }
        if (lockMaxTimer) {
          clearTimeout(lockMaxTimer);
          lockMaxTimer = null;
        }
        if (unbindUserCancel) {
          unbindUserCancel();
          unbindUserCancel = null;
        }
      }

      function syncActiveByScroll() {
        if (state.lock) return;
        var offset = getHeaderOffsetHeight(root, headerEl);
        var matched = computeMatchedAnchorIndex(anchorItemMap, cachedSections, anchorKeys, offset);
        if (matched !== null && anchorItemMap[matched]) setActive(root, anchorItemMap[matched], state);
      }

      function bindUserIntentCancel() {
        function onWheel() {
          if (state.lock) clearLock();
        }
        function onTouchStart() {
          if (state.lock) clearLock();
        }
        function onPointerDown() {
          if (state.lock) clearLock();
        }
        function onKeyDown(ev) {
          if (!state.lock) return;
          var k = ev && ev.key ? ev.key : '';
          if (
            k === 'ArrowUp' ||
            k === 'ArrowDown' ||
            k === 'PageUp' ||
            k === 'PageDown' ||
            k === 'Home' ||
            k === 'End' ||
            k === ' ' ||
            k === 'Spacebar'
          )
            clearLock();
        }
        window.addEventListener('wheel', onWheel, { passive: true, capture: true });
        window.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
        window.addEventListener('pointerdown', onPointerDown, { passive: true, capture: true });
        window.addEventListener('keydown', onKeyDown, true);
        return function () {
          window.removeEventListener('wheel', onWheel, true);
          window.removeEventListener('touchstart', onTouchStart, true);
          window.removeEventListener('pointerdown', onPointerDown, true);
          window.removeEventListener('keydown', onKeyDown, true);
        };
      }

      function beginLock() {
        clearLock();
        state.lock = true;
        unbindUserCancel = bindUserIntentCancel();
        lockMaxTimer = setTimeout(function () {
          clearLock();
          syncActiveByScroll();
        }, LOCK_MAX_MS);
      }

      function armIdleUnlock() {
        if (lockIdleTimer) clearTimeout(lockIdleTimer);
        lockIdleTimer = setTimeout(function () {
          if (!state.lock) return;
          clearLock();
          syncActiveByScroll();
        }, LOCK_IDLE_MS);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateStickyTop(root, headerEl);

          if (state.lock) {
            armIdleUnlock();
            return;
          }

          syncActiveByScroll();
        });
      }

      // 监听按钮点击（capture 阶段），设置锁定
      function onClickCapture(ev) {
        var target = ev && ev.target ? ev.target : null;
        if (!target || !target.closest) return;
        var btn = target.closest(SCROLL_BTN_SELECTOR);
        if (!btn || !root.contains(btn)) return;

        // 立即设置激活状态
        setActive(root, btn, state);

        // 设置锁定，防止滚动回显覆盖
        beginLock();
      }

      root.addEventListener('click', onClickCapture, true);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      onScroll();

      var ro = null;
      if (headerEl && window.ResizeObserver) {
        ro = new ResizeObserver(function () {
          updateStickyTop(root, headerEl);
          onScroll();
        });
        ro.observe(headerEl);
      }

      controllers.set(root, {
        destroy: function () {
          clearLock();
          root.removeEventListener('click', onClickCapture, true);
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          if (ro && ro.disconnect) ro.disconnect();
          if (mo && mo.disconnect) mo.disconnect();
          var stickyHost = root.__ndevStickyHost;
          if (stickyHost && stickyHost.classList) stickyHost.classList.remove('ndev-navbar__sticky-wrapper');
          delete root.__ndevStickyHost;
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        initOne(root);
      });
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        destroyOne(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-x30-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-x30-sale';
    const ROOT_SELECTOR = '[data-ndev-x30-sale]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 初始化逻辑（建议事件绑定都挂在 root 上，并在 destroy 里移除）

      controllers.set(root, {
        root: root,
        destroy: function () {
          // 清理事件监听器、定时器等（注意移除你在 init 里绑定的监听）
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'page-banner';
    const ROOT_SELECTOR = '[data-page-banner]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      destroyOne(root);

      const swiperEl = root.querySelector('[data-page-banner-swiper]');
      if (!swiperEl || typeof window.Swiper === 'undefined') return;

      const configEl = root.querySelector('[data-page-banner-config]');
      let config = {};
      if (configEl && configEl.textContent) {
        try { config = JSON.parse(configEl.textContent); } catch (e) {}
      }

      // 注意：Swiper 初始化时可能会触发 slideChange（会调用 updateVerticalTabs/updateHorizontalTabs）
      // 因此这些变量必须在 new Swiper() 之前完成初始化，避免 TDZ 报错导致整个初始化中断。
      const verticalTabsContainer = root.querySelector('[data-page-banner-vertical-tabs]');
      const horizontalTabsContainer = root.querySelector('[data-page-banner-horizontal-tabs]');
      const horizontalTabsPcContainer = root.querySelector('[data-page-banner-horizontal-tabs-pc]');
      const itemHeight = 19.2;

      // 兼容两种 DOM 形态：
      // - Theme Editor: `.swiper-wrapper > .shopify-block > .swiper-slide.page-banner__slide`
      // - Storefront/Preview: `.swiper-wrapper > .swiper-slide.page-banner__slide`
      const slideWrappers = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-wrapper > .shopify-block'));
      const hasShopifyBlockWrapper = slideWrappers.length > 0;
      const slideEls = hasShopifyBlockWrapper
        ? slideWrappers
        : Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-wrapper > .page-banner__slide'));

      const slideCount = slideEls.length;
      const enableLoop = slideCount > 1;
      const duration = (Number(config.duration) || 5) * 1000;
      const enableAutoplay = config.autoplay !== false;
      const showPagination = config.showPagination !== false;
      const paginationVariant = (config.paginationVariant || root.getAttribute('data-page-banner-pagination-variant') || 'tabs');
      const useCustomTabs = (paginationVariant === 'tabs' || paginationVariant === 'tabs_pc_horizontal');

      const listeners = [];
      let resizeTimeout = null;
      let progressInterval = null;
      let currentProgress = 0;

      function on(el, type, handler) {
        if (!el) return;
        el.addEventListener(type, handler);
        listeners.push({ el, type, handler });
      }

      let swiper = null;

      const swiperOptions = {
        loop: enableLoop,
        slidesPerView: 1,
        spaceBetween: 0,
        simulateTouch: enableLoop,
        allowTouchMove: enableLoop,
        autoplay: enableAutoplay ? { delay: duration, disableOnInteraction: false } : false,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        on: {
          slideChange: function () {
            if (showPagination && useCustomTabs) {
              updateVerticalTabs(this.realIndex);
              updateHorizontalTabs(this.realIndex);
              updateHorizontalTabsPc(this.realIndex);
              resetProgress(this);
            }
          }
        }
      };

      if (hasShopifyBlockWrapper) {
        swiperOptions.slideClass = 'shopify-block';
      } else {
        swiperOptions.slideClass = 'page-banner__slide';
      }

      swiper = new Swiper(swiperEl, swiperOptions);

      function buildTabs() {
        if (verticalTabsContainer) verticalTabsContainer.innerHTML = '';
        if (horizontalTabsContainer) horizontalTabsContainer.innerHTML = '';
        if (horizontalTabsPcContainer) horizontalTabsPcContainer.innerHTML = '';

        if (!showPagination || slideCount <= 1 || !useCustomTabs) {
          if (verticalTabsContainer) verticalTabsContainer.style.display = 'none';
          if (horizontalTabsContainer) horizontalTabsContainer.style.display = 'none';
          if (horizontalTabsPcContainer) horizontalTabsPcContainer.style.display = 'none';
          return;
        }

        if (verticalTabsContainer) {
          verticalTabsContainer.style.removeProperty('display');
          verticalTabsContainer.style.setProperty('--count', slideCount);
        }
        if (horizontalTabsContainer) {
          horizontalTabsContainer.style.removeProperty('display');
          horizontalTabsContainer.style.setProperty('--count', slideCount);
        }
        if (horizontalTabsPcContainer) {
          horizontalTabsPcContainer.style.removeProperty('display');
          horizontalTabsPcContainer.style.setProperty('--count', slideCount);
        }

        slideEls.forEach((holder, index) => {
          const slide = (holder && holder.classList && holder.classList.contains('page-banner__slide'))
            ? holder
            : (holder ? holder.querySelector('.page-banner__slide') : null);
          const title = (slide && slide.getAttribute && slide.getAttribute('data-tab-title')) || ('Slide ' + (index + 1));
          if (verticalTabsContainer && paginationVariant === 'tabs') {
            const vTab = document.createElement('div');
            vTab.className = 'page-banner__vertical-tab' + (index === 0 ? ' page-banner__vertical-tab--active' : '');
            vTab.textContent = title;
            verticalTabsContainer.appendChild(vTab);
          }

          if (horizontalTabsPcContainer && paginationVariant === 'tabs_pc_horizontal') {
            const pcTab = document.createElement('div');
            pcTab.className = 'page-banner__horizontal-tab-pc' + (index === 0 ? ' page-banner__horizontal-tab-pc--active' : '');
            if (title) {
              const span = document.createElement('span');
              span.className = 'page-banner__horizontal-tab-pc-title';
              span.textContent = title;
              pcTab.appendChild(span);
            }
            horizontalTabsPcContainer.appendChild(pcTab);
          }

          if (horizontalTabsContainer) {
            const hTab = document.createElement('div');
            hTab.className = 'page-banner__horizontal-tab' + (index === 0 ? ' page-banner__horizontal-tab--active' : '');
            horizontalTabsContainer.appendChild(hTab);
          }
        });
      }

      function startProgress() {
        stopProgress();
        currentProgress = 0;
        const activeHorizontalTab = root.querySelector('.page-banner__horizontal-tab--active');
        const activeHorizontalTabPc = root.querySelector('.page-banner__horizontal-tab-pc--active');
        const updateInterval = 50;
        const progressStep = (100 / (duration / updateInterval));
        progressInterval = setInterval(() => {
          currentProgress += progressStep;
          if (currentProgress >= 100) {
            currentProgress = 100;
            clearInterval(progressInterval);
          }
          if (verticalTabsContainer) {
            const heightInPixels = (currentProgress / 100) * itemHeight;
            verticalTabsContainer.style.setProperty('--actived-item-height', heightInPixels + 'px');
          }
          if (activeHorizontalTab) {
            activeHorizontalTab.style.setProperty('--progress-width', currentProgress + '%');
          }
          if (activeHorizontalTabPc) {
            activeHorizontalTabPc.style.setProperty('--progress-width', currentProgress + '%');
          }
        }, updateInterval);
      }

      function stopProgress() {
        if (progressInterval) {
          clearInterval(progressInterval);
          progressInterval = null;
        }
      }

      function resetProgress(swiperInstance) {
        stopProgress();
        currentProgress = 0;
        const activeHorizontalTab = root.querySelector('.page-banner__horizontal-tab--active');
        const activeHorizontalTabPc = root.querySelector('.page-banner__horizontal-tab-pc--active');
        if (verticalTabsContainer) {
          verticalTabsContainer.style.setProperty('--actived-item-height', '0px');
        }
        if (activeHorizontalTab) {
          activeHorizontalTab.style.setProperty('--progress-width', '0%');
        }
        if (activeHorizontalTabPc) {
          activeHorizontalTabPc.style.setProperty('--progress-width', '0%');
        }
        const s = swiperInstance || swiper;
        if (enableAutoplay && s && s.autoplay && s.autoplay.running) {
          setTimeout(() => startProgress(), 100);
        }
      }

      function updateVerticalTabs(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__vertical-tab');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__vertical-tab--active');
          else tab.classList.remove('page-banner__vertical-tab--active');
        });
        if (verticalTabsContainer && tabs.length > 0) {
          const itemGap = 18;
          const topPosition = realIndex * (itemHeight + itemGap);
          verticalTabsContainer.style.setProperty('--top', topPosition + 'px');
        }
      }

      function updateHorizontalTabs(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__horizontal-tab');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__horizontal-tab--active');
          else tab.classList.remove('page-banner__horizontal-tab--active');
        });
      }

      function updateHorizontalTabsPc(realIndex) {
        const tabs = root.querySelectorAll('.page-banner__horizontal-tab-pc');
        tabs.forEach((tab, index) => {
          if (index === realIndex) tab.classList.add('page-banner__horizontal-tab-pc--active');
          else tab.classList.remove('page-banner__horizontal-tab-pc--active');
        });
      }

      function initTabs() {
        const vTabs = root.querySelectorAll('.page-banner__vertical-tab');
        const hTabs = root.querySelectorAll('.page-banner__horizontal-tab');
        const hPcTabs = root.querySelectorAll('.page-banner__horizontal-tab-pc');
        vTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
        hTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
        hPcTabs.forEach((tab, index) => {
          on(tab, 'click', function () {
            if (enableLoop && swiper.slideToLoop) swiper.slideToLoop(index);
            else swiper.slideTo(index);
          });
        });
      }

      function initButtonActions() {
        const buttons = root.querySelectorAll('.page-banner__btn');
        buttons.forEach(button => {
          on(button, 'click', function (e) {
            const actionType = this.getAttribute('data-action-type');
            if (actionType === 'scroll') {
              e.preventDefault();
              const sectionIndex = parseInt(this.getAttribute('data-scroll-to-section'), 10) || 1;
              const sections = Array.from(document.querySelectorAll('#main-content .shopify-section') || []);
              const targetSection = sections[sectionIndex - 1];
              if (targetSection) {
                targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            } else if (actionType === 'spin') {
              e.preventDefault();
              var spinLink = this.getAttribute('data-spin-link');
              if (spinLink) {
                location.href = spinLink;
                return;
              }
              var spinTrigger = document.getElementById('crazyrocket-launch-icon');
              if (spinTrigger) {
                spinTrigger.click();
              }
            }
          });
        });
      }

      function isInteractiveTarget(target) {
        if (!target || !target.closest) return false;
        return Boolean(
          target.closest(
            'a, button, input, textarea, select, option, label, summary, [role="button"], [data-page-banner-no-slide-link]'
          )
        );
      }

      function navigateBySlide(slide) {
        if (!slide) return;
        const href = slide.getAttribute('data-slide-href');
        if (!href) return;
        const target = slide.getAttribute('data-slide-target');
        if (target === '_blank') window.open(href, '_blank');
        else window.location.href = href;
      }

      function initSlideLinkActions() {
        // 用事件委托覆盖 loop 下的克隆 slide（clone 节点不会继承监听器）
        on(swiperEl, 'click', function (e) {
          if (swiper && swiper.allowClick === false) return;
          if (isInteractiveTarget(e && e.target)) return;
          const slide = e && e.target && e.target.closest
            ? e.target.closest('.page-banner__slide[data-slide-href]')
            : null;
          if (!slide || !swiperEl.contains(slide)) return;
          navigateBySlide(slide);
        });

        on(swiperEl, 'keydown', function (e) {
          if (!e) return;
          if (swiper && swiper.allowClick === false) return;
          if (isInteractiveTarget(e && e.target)) return;
          const key = e.key || e.code;
          if (!(key === 'Enter' || key === ' ' || key === 'Spacebar')) return;
          const slide = e.target && e.target.closest
            ? e.target.closest('.page-banner__slide[data-slide-href]')
            : null;
          if (!slide || !swiperEl.contains(slide)) return;
          e.preventDefault();
          navigateBySlide(slide);
        });
      }

      if (swiper) {
        buildTabs();
        initTabs();
        initButtonActions();
        initSlideLinkActions();
        if (showPagination && useCustomTabs) {
          updateVerticalTabs(0);
          updateHorizontalTabs(0);
          updateHorizontalTabsPc(0);
          if (enableAutoplay && swiper.autoplay && swiper.autoplay.running) {
            setTimeout(() => startProgress(), 100);
          }
        } else {
          if (verticalTabsContainer) verticalTabsContainer.style.display = 'none';
          if (horizontalTabsContainer) horizontalTabsContainer.style.display = 'none';
          if (horizontalTabsPcContainer) horizontalTabsPcContainer.style.display = 'none';
        }
        on(window, 'resize', function () {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            if (swiper && swiper.update) swiper.update();
          }, 250);
        });
      }

      root.setAttribute(INIT_ATTR, '1');
      controllers.set(root, {
        root: root,
        destroy: function () {
          listeners.forEach(item => item.el.removeEventListener(item.type, item.handler));
          if (resizeTimeout) clearTimeout(resizeTimeout);
          stopProgress();
          if (swiper && swiper.destroy) swiper.destroy(true, true);
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page1"]) return;
  try {
    
  (function() {
      let hydro = { install: 'yes', list: [] };
      let lastTar = null;
      const btn = document.getElementById('page1-next');
      const events = Array.prototype.slice.apply(document.getElementById('page1-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item; 
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          if (index === 2) {
              hydro.list[0] = { result: 'no' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/bathroom';
          } else if (index === 4) {
              hydro.list[0] = { result: 'no' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/balcony';
          } else {
              hydro.list[0] = { result: 'yes' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/hydroease-question2';
          }
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page2"]) return;
  try {
    
  (function() {
      let hydro = window.sessionStorage.getItem('__hydro__');
      try {
          hydro = JSON.parse(hydro);
      } catch (e) {
          hydro = { install: 'no' };
      }
      document.getElementById('page2-no').addEventListener('click', function() {
          hydro.install = 'no';
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question3';
      });

      document.getElementById('page2-yes').addEventListener('click', function() {
          if (hydro.install === 'yes') {
              hydro.list[1] = { result: 'yes' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question3';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page3"]) return;
  try {
    
(function() {
    let lastTar = null;
    const btn = document.getElementById('page3-next');
    const events = Array.prototype.slice.apply(document.getElementById('page3-room').querySelectorAll('.item'));
    events.forEach(item => {
        item.addEventListener('click', function() {
            if (lastTar !== null) {
                lastTar.classList.remove('selected');
            } 

            lastTar = item;
            item.classList.add('selected');
            btn.style.display = 'block';
        });
    });

    btn.addEventListener('click', function() {
        const index = Number(lastTar.dataset.index);
        let hydro = window.sessionStorage.getItem('__hydro__');
        try {
            hydro = JSON.parse(hydro);
            if (index === 1) {
                hydro.intall = 'no';
            } else {
                hydro.list[2] = { result: 'yes' };
            }
        } catch (e) {
            hydro = { install: 'no' };
        }
        window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
        location.href = '/pages/hydroease-question4';
    });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page4"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page4-next');
      const events = Array.prototype.slice.apply(document.getElementById('page4-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected'); 
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[3] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question5';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page5"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page5-next');
      const events = Array.prototype.slice.apply(document.getElementById('page5-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected'); 
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[4] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question6';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page6"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page6-next');
      const events = Array.prototype.slice.apply(document.getElementById('page6-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) { 
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[5] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question7';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page7"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page7-next');
      const events = Array.prototype.slice.apply(document.getElementById('page7-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          }); 
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          window.sessionStorage.removeItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[6] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }

          if (hydro.install === 'yes') {
              if (hydro.list.filter(r => r && r.result === 'yes').length === 7) {
                  location.href = '/pages/freo-hydroease-product';
                  return false;
              }
          }

          location.href = '/pages/freo-product';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixlee-widget"]) return;
  try {
    
  (function(){
    window.PixleeAsyncInit = function() { //2
        Pixlee.init({ apiKey: "t8hC3pFQ7Vc2z2RTMZrm" });
        Pixlee.addCategoryWidget({ widgetId: "7876231", containerId: 'pixlee-widget-box' });
        Pixlee.resizeWidget();
    };
    var pix = document.createElement('script');
    pix.src = '//assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(pix, s);
  })();

  } catch(e) { console.error(e); }
})();
})();
